<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <HeaderMenu title="Пульт от телевизора" class="mx-6 mb-6" back-page/>
            <v-layout class="remote-control px-6" column>
                <v-flex xs12 class="shut-off-btn">
                    <v-btn class="remote-btn-round" @click="sendCommand">
                        <SwitchIcon/>
                    </v-btn>
                    <v-btn class="remote-btn-round" @click="sendCommand">
                        <MuteIcon/>
                    </v-btn>
                </v-flex>
                <v-flex xs12 class="remote-btns">
                    <div class="button-group">
                        <div class="outter-circle">
                            <div class="inner-parts up">
                                <ArrowRightIcon @click="sendCommand"/>
                            </div>
                            <div class="inner-parts right">
                                <ArrowRightIcon @click="sendCommand"/>
                            </div>
                            <div class="inner-parts left">
                                <ArrowRightIcon @click="sendCommand"/>
                            </div>
                            <div class="inner-parts down">
                                <ArrowRightIcon @click="sendCommand"/>
                            </div>
                            <div class="inner-circle">
                                <span class="ok btn-round-text" @click="sendCommand">OK</span>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex xs12 class="volume-control">
                    <v-btn class="remote-volume" @click="sendCommand">
                        <MinusIcon/>
                    </v-btn>
                    <div class="remote-volume">
                        <VolumeIcon/>
                    </div>
                    <v-btn class="remote-volume" @click="sendCommand">
                        <PlusIcon/>
                    </v-btn>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import SwitchIcon from "@/assets/icons/SwitchIcon";
import MuteIcon from "@/assets/icons/MuteIcon";
import MinusIcon from "@/assets/icons/MinusIcon";
import PlusIcon from "@/assets/icons/PlusIcon";
import VolumeIcon from "@/assets/icons/VolumeIcon";
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";

export default {
    name: "DeviceTV",
    components: {
        HeaderMenu,
        SwitchIcon,
        MuteIcon,
        MinusIcon,
        PlusIcon,
        VolumeIcon,
        ArrowRightIcon,
    },
    data() {
        return {
            deviceUID: null,
        };
    },
    created() {
        this.deviceUID = this.$route.params.device;
    },
    methods: {
        sendCommand() {
            this.$http.put('/devices/guest/device/' + this.deviceUID + '/state', {
                command: "on"
            })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
}
</script>

<style lang="scss">
.main-container.container-fixed .remote-control {
    height: calc(100% - 54px);
    justify-content: flex-start;

    .shut-off-btn {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        margin-bottom: 36px;
        max-height: 80px;
    }

    .remote-btn-round.v-btn.theme--light {
        padding: 20px;
        background: rgba(247, 247, 249, 0.38);
        box-shadow: 0px 4px 15px rgba(37, 37, 37, 0.1);
        display: inline-flex;
        width: 72px;
        height: 72px;
        border-radius: 50px;

        &.v-btn:before {
            content: none;
        }
    }

    .volume-control {
        display: flex;
        margin: 20px;
        padding: 12px 24px;
        background: rgba(247, 247, 249, 0.38);
        box-shadow: 0px 4px 15px rgba(37, 37, 37, 0.1);
        border-radius: 30px;
        justify-content: space-between;
        max-height: 72px;
        align-items: center;

        .remote-volume {
            background: initial;
            box-shadow: none;
            display: inline-flex;

            /*&.v-btn:before {*/
            /*    content: none;*/
            /*}*/
        }
    }

    .remote-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        margin-bottom: 36px;
        max-height: 230px;

        .button-group {
            width: 220px;
            height: 220px;
        }

        .outter-circle {
            position: relative;
            width: 220px;
            height: 220px;
            background: rgba(247, 247, 249, 0.38);
            box-shadow: 0px 4px 15px rgba(37, 37, 37, 0.1);
            border-radius: 100%;
            overflow: hidden;
            transform-origin: center;
            transform: rotate(45deg);
        }

        .inner-parts {
            float: left;
            width: 110px;
            height: 110px;
            line-height: 110px;
            text-align: center;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            &.up {
                transform: rotate(225deg);
                padding-left: 15px;
            }

            &.down {
                transform: rotate(45deg);
                padding-left: 15px;
            }

            &.left {
                transform: rotate(135deg);
                padding-left: 15px;
            }

            &.right {
                transform: rotate(315deg);
                padding-left: 15px;
            }

            svg {
                stroke: #130F26;
            }
        }

        .inner-circle {
            position: absolute;
            margin-top: 55px;
            margin-left: 55px;
            width: 110px;
            height: 110px;
            line-height: 110px;
            text-align: center;
            border-radius: 100%;
            background: rgba(247, 247, 249, 0.38);
            box-shadow: 0px 4px 15px rgba(37, 37, 37, 0.15);
        }

        .btn-round-text {
            display: inline-block;
            transform: rotate(-45deg);font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: #161616;
        }
    }
}
</style>